import classNames from "classnames"
import { FC, Fragment } from "react"

import styles from './icon.module.css'
import { IconAnimations, IconProps, ImgIconProps, SvgIconProps } from "./icon.type"

const Icon: FC<IconProps> = ({
    icon,
    fill = 'none',
    animation,
    className,
    alt,
    ...rest
}) => {
    const blankImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

    const isSvg = icon && typeof icon === "object" && "id" in icon && "spritePath" in icon

    const href = isSvg ? `${ icon.spritePath }#${ icon.id }` : typeof icon === 'string' ? icon : blankImage

    const spriteIconClassNames = classNames(
        styles.spriteIcon,
        { [styles.rotateIcon] : animation && animation === IconAnimations.Rotate },
        className,
    )
    return (
        <Fragment>
            { isSvg ? (
                <svg fill={ fill } className={ spriteIconClassNames } { ...(rest as SvgIconProps) }>
                    <use href={ href } />
                </svg>
            ) : (
                <img
                    alt={ alt }
                    src={ href }
                    className={ spriteIconClassNames }
                    { ...(rest as ImgIconProps) }
                />
            ) }
        </Fragment>
    )
}
    

export default Icon
